import type { RiskLevel } from '../types';
import { RISK_COLORS } from '../types';
import { RISK_PT } from '../lib/concelhos';

const ORDER: RiskLevel[] = ['Low', 'Moderate', 'High', 'Extreme'];

/**
 * Horizontal stacked bar of the risk-level split across a concelho's 1 km cells.
 * Segments below ~1.5% are still shown as a hairline so Extreme never vanishes.
 */
export default function RiskDistributionBar({
  risk,
  total,
}: {
  risk: Record<RiskLevel, number>;
  total: number;
}) {
  if (!total) return null;
  return (
    <div>
      <div className="flex h-3 w-full overflow-hidden rounded-full bg-ink-700">
        {ORDER.map((lvl) => {
          const n = risk[lvl] ?? 0;
          if (!n) return null;
          const pct = (100 * n) / total;
          return (
            <div
              key={lvl}
              style={{ width: `${Math.max(pct, 0.6)}%`, backgroundColor: RISK_COLORS[lvl] }}
              title={`${RISK_PT[lvl]}: ${n} (${pct.toFixed(1)}%)`}
            />
          );
        })}
      </div>
      <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 font-mono text-xs text-mist-muted">
        {ORDER.map((lvl) => {
          const n = risk[lvl] ?? 0;
          const pct = total ? (100 * n) / total : 0;
          return (
            <span key={lvl} className="inline-flex items-center gap-1.5">
              <span
                className="inline-block h-2.5 w-2.5 rounded-sm"
                style={{ backgroundColor: RISK_COLORS[lvl] }}
              />
              {RISK_PT[lvl]} {pct.toFixed(pct < 10 ? 1 : 0)}%
            </span>
          );
        })}
      </div>
    </div>
  );
}
